import { ServiceReviewsViewModel } from './ViewModel/ServiceReviewsViewModel.csharp';

export const collectReviews = (serviceReviews: ServiceReviewsViewModel) => {
    const { googleMerchantId, orderId, customerName, customerEmail, deliveryDate, trustpilotId, shouldSendTrustpilotInvitation } = serviceReviews;
    let isTrustpilotSent = false;
    let trustpilotInterval: NodeJS.Timeout | number;

    if (googleMerchantId) {
        /* eslint-disable @typescript-eslint/no-explicit-any */
        (window as any).renderOptIn = function () {
            (window as any).gapi.load('surveyoptin', function () {
                (window as any).gapi.surveyoptin.render({
                    merchant_id: googleMerchantId,
                    order_id: orderId,
                    email: customerEmail,
                    delivery_country: 'no',
                    estimated_delivery_date: new Date(deliveryDate).toISOString().slice(0, 10),
                    opt_in_style: 'BOTTOM_LEFT_DIALOG'
                });
            });
        };
        /* eslint-enable @typescript-eslint/no-explicit-any */
    }

    const sendTrustpilotInvitation = () => {
        // eslint-disable-next-line
        // @ts-ignore
        if (typeof tp !== 'undefined' && !isTrustpilotSent) {
            // eslint-disable-next-line
            // @ts-ignore
            tp('createInvitation', {
                recipientEmail: customerEmail,
                recipientName: customerName,
                referenceId: orderId,
                source: 'InvitationScript'
            });

            isTrustpilotSent = true;
            clearInterval(trustpilotInterval as number);
        }
    };

    if (trustpilotId && shouldSendTrustpilotInvitation) {
        trustpilotInterval = setInterval(sendTrustpilotInvitation, 500);
    }
};
